export enum DrawFilterType {
    NoBudget = 1,
    Request = 2,
    Inspecting = 3,
    NeedToFund = 4,
    Accomodation = 5,
    OutOfBalance = 6,
}

export const drawFilterTypes = [
    {
        id: 1,
        type: DrawFilterType.NoBudget,
        name: 'No Budget',
    },
    {
        id: 2,
        type: DrawFilterType.Request,
        name: 'Request',
    },
    {
        id: 3,
        type: DrawFilterType.Inspecting,
        name: 'Inspecting',
    },
    {
        id: 4,
        type: DrawFilterType.NeedToFund,
        name: 'Need To Fund',
    },
    {
        id: 5,
        type: DrawFilterType.Accomodation,
        name: 'Accomodation',
    },
    {
        id: 6,
        type: DrawFilterType.OutOfBalance,
        name: 'Out-Of-Balance',
    },
];
